export default {
  breadcrumb: {
    taskList: '任务列表',
  },
  map: {
    title: '实时轨迹',
    legendCurrent: '当前位置',
    legendPath: '行驶轨迹',
  },
  video: {
    title: '实时视频',
    live: '直播中',
    detectionVideo: '检测视频',
    detectStream: '机器狗检测视频流',
  },
  dogInfo: {
    title: '机器狗信息',
    battery: '电量',
    batteryTemperature: '电池温度',
    voltage: '电压',
    position: '位置',
    positionXY: 'X: {x}，Y: {y}',
    noValue: '--',
    noValuePercent: '--%',
    postureStanding: '站立中',
    postureLying: '趴下',
    postureUnknown: '未知',
    selfCheck: '自检状态',
    selfCheckReady: '正常',
  },
  control: {
    title: '远程控制',
    taskSection: '任务控制',
    moveSection: '移动控制',
    end: '结束',
    stand: '站立',
    lie: '趴下',
    pause: '暂停',
    resume: '继续',
    posture: '姿态',
    moveHint: '需站立姿态后方可移动',
  },
  alarmList: {
    total: '共 {count} 条',
  },
  trajectoryMap: {
    connectingTitle: '正在连接地图…',
    connectingSubtitle: '等待 ROS `/map` 数据推送',
    defaultAlarmLabel: '告警',
  },
  messages: {
    startSuccess: '启动成功',
    startFailed: '巡检任务启动失败',
    stopSuccess: '停止成功',
    stopFailed: '巡检任务停止失败',
    missingSn: '未获取到设备SN',
    postureSuccess: '{action}成功',
    postureFailed: '姿态控制失败',
    noActiveTask: '暂无进行中的任务',
    pauseSuccess: '暂停成功',
    pauseFailed: '暂停任务失败',
    resumeSuccess: '继续成功',
    resumeFailed: '继续任务失败',
  },
}
